// CustomTitle.js
import React from 'react';

const CustomTitle = ({ text }) => {
  return (
    <span style={{ color: 'blue', fontWeight: 'bold' }}>{text}</span>
  );
};

export default CustomTitle;